// import React, { useEffect, useState } from "react";
// import { GetAccess } from "../../../../Components/Utils/roles";
// import EditIcon from "../../../../Components/Icons/Edit";
// import CircleXIcon from "../../../../Components/Icons/CircleXIcon";
// import CircleCheckIcon from "../../../../Components/Icons/CircleCheckIcon";
// import ModalContainer from "../../../../Components/Others/ModalContainer";
// import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import { NuInput, NuTextArea } from "../../../../Components/Utils/Input";
// import axiosInstance from "../../../../Services/axiosCommon";
// import { useToast } from "../../../../Components/Others/ToastServices";

// function ViewMore({ getData, data }) {
//   const toast = useToast();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEdit, setIsEdit] = useState(false);
//   const [isEnable, setIsEnable] = useState(false);
//   const { handle } = useDeleteData(getData);

//   const handleDelete = async () =>
//     handle(`/email_templates/${data?.id}`, setIsModalOpen);

//   // Form state
//   const [createNew, setCreateNew] = useState({
//     subject: "",
//     message: "",
//     thanksMessage: "",
//     enable: "",
//     html: ""
//   });

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: createNew,
//     validateOnChange: false,
//     validateOnBlur: false,
//     validationSchema: yup.object({}),
//     onSubmit: async (value, { resetForm }) => {
//       await axiosInstance
//         .put(`/email_templates/${data?.id}`, value)
//         .then((res) => {
//           if (res?.data?.status === true) {
//             toast.open({
//               type: "success",
//               message: "Success",
//               description: res.data?.msg || "Updated Successfully."
//             });
//             resetForm();
//             getData();
//             setIsEdit(false);
//           } else {
//             toast.open({
//               type: "warning",
//               message: "Warning",
//               description:
//                 res.data?.msg || res.data.error || "Something went wrong."
//             });
//           }
//         })
//         .catch(() => {
//           toast.open({
//             type: "error",
//             message: "Error",
//             description: "Network error."
//           });
//         });
//     }
//   });

//   useEffect(() => {
//     setCreateNew({
//       subject: data?.subject || "",
//       message: data?.message || "",
//       thanksMessage: data?.thanksMessage || "",
//       enable: data?.enable || "",
//       html: data?.html || "" // pull html from backend
//     });
//   }, [data]);

//   function CloseEdit() {
//     formik.resetForm();
//     setIsEdit(false);
//   }

//   async function EnableOrDisable() {
//     let value = { ...data };
//     value.enable = data?.enable === true ? false : true;
//     await axiosInstance
//       .put(`/email_templates/${data?.id}`, value)
//       .then((res) => {
//         if (res?.data?.status === true) {
//           toast.open({
//             type: "success",
//             message: "Success",
//             description: res.data?.msg || "Updated Successfully."
//           });
//           getData();
//           setIsEnable(false);
//         } else {
//           toast.open({
//             type: "warning",
//             message: "Warning",
//             description:
//               res.data?.msg || res.data.error || "Something went wrong."
//           });
//         }
//       })
//       .catch(() => {
//         toast.open({
//           type: "error",
//           message: "Error",
//           description: "Network error."
//         });
//       });
//   }

//   // Helper: protect placeholders like ${name}
//   const protectPlaceholders = (text) => {
//     if (!text) return "";
//     const regex = /\$\{.*?\}/g;
//     return text.split(regex).reduce((acc, part, i, arr) => {
//       acc.push(part);
//       if (i < arr.length - 1) {
//         const match = text.match(regex)[i];
//         acc.push(
//           <span
//             key={i}
//             className="bg-yellow-100 text-red-600 font-mono px-1 rounded"
//             contentEditable={false}
//           >
//             {match}
//           </span>
//         );
//       }
//       return acc;
//     }, []);
//   };

//   // Helper: wrap plain text with line breaks
//   const formatPlainText = (text) => {
//     if (!text) return "Your message will appear here...";
//     return text.split("\n").map((line, i) => (
//       <span key={i}>
//         {protectPlaceholders(line)}
//         <br />
//       </span>
//     ));
//   };

//   // Preview function
//   const renderFullTemplate = () => {
//     const { subject, message, thanksMessage, html } = formik.values;

//     if (html && html.trim() !== "") {
//       return (
//         <iframe
//           sandbox="allow-same-origin"
//           srcDoc={html}
//           className="w-full h-[80vh] border-none"
//           title="Email Template Preview"
//         />
//       );
//     }

//     if (message?.includes("<") || subject?.includes("<")) {
//       const fullHtml = `
//         <h4>${subject || "Your subject will appear here"}</h4>
//         <div>${message || "Your message will appear here..."}</div>
//         ${thanksMessage ? `<footer>${thanksMessage}</footer>` : ""}
//       `;
//       return (
//         <iframe
//           sandbox="allow-same-origin"
//           srcDoc={fullHtml}
//           className="w-full h-[80vh] border-none"
//           title="Email Template Preview"
//         />
//       );
//     }

//     return (
//       <div className="text-sm text-gray-700 p-4 bg-gray-50 rounded h-[80vh] overflow-y-auto">
//         <h4 className="text-base font-bold mb-2">
//           {protectPlaceholders(subject) || "Your subject will appear here"}
//         </h4>
//         <div>{formatPlainText(message)}</div>
//         {thanksMessage && (
//           <footer className="mt-4 italic text-gray-500">
//             {protectPlaceholders(thanksMessage)}
//           </footer>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       {/* Action buttons */}
//       <div className="w-full flex justify-start items-center">
//         <div className="w-full flex justify-center gap-2 ">
//           {GetAccess("emailtemplates_edit") && (
//             <span className="cursor-pointer" onClick={() => setIsEdit(true)}>
//               <EditIcon color="skyblue" width={"12"} height={"12"} />
//             </span>
//           )}
//           {GetAccess("emailtemplates_edit") && (
//             <span className="cursor-pointer" onClick={() => setIsEnable(true)}>
//               {data?.enable === true ? (
//                 <CircleCheckIcon color="green" />
//               ) : (
//                 <CircleXIcon color="red" />
//               )}
//             </span>
//           )}
//         </div>
//       </div>

//       {/* Delete confirm */}
//       <ModalContainer
//         visiable={isModalOpen}
//         title="Warning"
//         content={`Are you sure, This Email template will be removed from Template list!`}
//         handleClick={() => handleDelete()}
//         closeModal={() => setIsModalOpen(false)}
//       />

//       {/* Enable / Disable confirm */}
//       <ModalContainer
//         visiable={isEnable}
//         title="Warning"
//         content={`Are you sure, You want ${
//           data?.enable ? "disable" : "enable"
//         } This Email template!`}
//         handleClick={() => EnableOrDisable()}
//         closeModal={() => setIsEnable(false)}
//       />

//       {/* Edit modal */}
//       <ModalContainer
//         visiable={isEdit}
//         title=""
//         content={
//           <div className="w-full relative">
//             <div className="w-full -mt-3 mb-2 flex justify-between items-center">
//               <p className="font-semibold text-sm 2xl:text-base">
//                 Edit Email Template
//               </p>
//             </div>

//             <div className="w-[90vw] h-[80vh] 2xl:w-[50vw] flex gap-4">
//               {/* Left: Form */}
//               <form
//                 onSubmit={formik.handleSubmit}
//                 className="w-1/2 flex flex-col gap-3"
//               >
//                 <NuInput
//                   type="text"
//                   label="Subject"
//                   placeholder="Enter Subject"
//                   formik={formik}
//                   name="subject"
//                   width="w-full md:-mt-2"
//                 />
//                 <NuTextArea
//                   label="HTML content"
//                   type="text"
//                   formik={formik}
//                   placeholder="Enter Message"
//                   name="html"
//                   new_width="w-full"
//                   row="6"
//                 />

//                 <div className="flex justify-end mt-4">
//                   <button
//                     type="button"
//                     onClick={CloseEdit}
//                     className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="bg-baseColor-primary px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//               {/* Right: Live Preview */}
//               <div className="w-1/2 border rounded bg-white shadow">
//                 {renderFullTemplate()}
//               </div>
//             </div>
//           </div>
//         }
//         handleClick={() => {}}
//         closeModal={() => setIsEdit(false)}
//         hasButton={false}
//         hasContent={true}
//       />
//     </>
//   );
// }

// export default ViewMore;


import React, { useEffect, useState } from "react";
import { GetAccess } from "../../../../Components/Utils/roles";
import EditIcon from "../../../../Components/Icons/Edit";
import CircleXIcon from "../../../../Components/Icons/CircleXIcon";
import CircleCheckIcon from "../../../../Components/Icons/CircleCheckIcon";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuInput, NuTextArea } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import { useToast } from "../../../../Components/Others/ToastServices";
import beautify from "js-beautify";

function ViewMore({ getData, data }) {
  const toast = useToast();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);

  const [isEnable, setIsEnable] = useState(false);
  const { handle } = useDeleteData(getData);

  const handleDelete = async () =>
    handle(`/email_templates/${data?.id}`, setIsModalOpen);

  // Form state
  const [createNew, setCreateNew] = useState({
    subject: "",
    message: "",
    thanksMessage: "",
    enable: "",
    html: ""
  });

  const formatHtml = (html) => {
    return beautify.html(html || "", {
      indent_size: 2,
      wrap_line_length: 80,
      preserve_newlines: true,
    });
  };

  // helper
  function protectHTML(original, edited) {
    if (!original) return edited;

    // 1. Match tags + placeholders from original
    const lockedRegex = /<\/?[^>]+>|{[^}]+}/g;
    const lockedOriginal = original.match(lockedRegex) || [];
    console.log(lockedOriginal,"lockedOriginal");
    

    // 2. Replace locked parts in edited with placeholders
    let i = 0;
    const safeEdited = edited.replace(lockedRegex, () => {
      return lockedOriginal[i++] || "";
    });

    return safeEdited;
  }


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      // restore locked content before save
      const safeHtml = protectHTML(data?.html, value.html);
      console.log(safeHtml,"safeHtml");

      await axiosInstance
        .put(`/email_templates/${data?.id}`, {
          ...value,
          html: safeHtml
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Updated Successfully."
            });
            resetForm();
            getData();
            setIsEdit(false);
          } else {
            toast.open({
              type: "warning",
              message: "Warning",
              description:
                res.data?.msg || res.data.error || "Something went wrong."
            });
          }
        })
        .catch(() => {
          toast.open({
            type: "error",
            message: "Error",
            description: "Network error."
          });
        });
    }
  });

  useEffect(() => {
    setCreateNew({
      subject: data?.subject || "",
      message: data?.message || "",
      thanksMessage: data?.thanksMessage || "",
      enable: data?.enable || "",
      html: formatHtml(data?.html) || "" // pull html from backend
    });
  }, [data]);

  function CloseEdit() {
    formik.resetForm();
    setIsEdit(false);
  }

  async function EnableOrDisable() {
    let value = { ...data };
    value.enable = data?.enable === true ? false : true;
    await axiosInstance
      .put(`/email_templates/${data?.id}`, value)
      .then((res) => {
        if (res?.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Updated Successfully."
          });
          getData();
          setIsEnable(false);
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description:
              res.data?.msg || res.data.error || "Something went wrong."
          });
        }
      })
      .catch(() => {
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error."
        });
      });
  }

  // Preview
  const renderFullTemplate = () => {
    const { subject, message, thanksMessage, html } = formik.values;

    if (html && html.trim() !== "") {
      return (
        <iframe
          sandbox="allow-same-origin"
          srcDoc={html}
          className="w-full h-[80vh] border-none"
          title="Email Template Preview"
        />
      );
    }

    return (
      <div className="text-sm text-gray-700 p-4 bg-gray-50 rounded h-[80vh] overflow-y-auto">
        <h4 className="text-base font-bold mb-2">
          {subject || "Your subject will appear here"}
        </h4>
        <div>{message || "Your message will appear here..."}</div>
        {thanksMessage && (
          <footer className="mt-4 italic text-gray-500">{thanksMessage}</footer>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Action buttons */}
      <div className="w-full flex justify-start items-center">
        <div className="w-full flex justify-center gap-2 ">
          {GetAccess("emailtemplates_edit") && (
            <span className="cursor-pointer" onClick={() => setIsEdit(true)}>
              <EditIcon color="skyblue" width={"12"} height={"12"} />
            </span>
          )}
          {GetAccess("emailtemplates_edit") && (
            <span className="cursor-pointer" onClick={() => setIsEnable(true)}>
              {data?.enable === true ? (
                <CircleCheckIcon color="green" />
              ) : (
                <CircleXIcon color="red" />
              )}
            </span>
          )}
        </div>
      </div>

      {/* Delete confirm */}
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, This Email template will be removed from Template list!`}
        handleClick={() => handleDelete()}
        closeModal={() => setIsModalOpen(false)}
      />

      {/* Enable / Disable confirm */}
      <ModalContainer
        visiable={isEnable}
        title="Warning"
        content={`Are you sure, You want ${
          data?.enable ? "disable" : "enable"
        } This Email template!`}
        handleClick={() => EnableOrDisable()}
        closeModal={() => setIsEnable(false)}
      />

      {/* Edit modal */}
      <ModalContainer
        visiable={isEdit}
        title=""
        content={
          <div className="w-full relative">
            <div className="w-full -mt-3 mb-2 flex justify-between items-center">
              <p className="font-semibold text-sm 2xl:text-base">
                Edit Email Template
              </p>
              <button
                  className="absolute top-0 right-0 text-red-600"
                  onClick={() => setIsEdit(false)}
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
            </div>

            <div className="w-[90vw] h-[80vh] 2xl:w-[50vw] flex gap-4">
              {/* Left: Form */}
              <form
                onSubmit={formik.handleSubmit}
                className="w-1/2 flex flex-col gap-3"
              >
                <NuInput
                  type="text"
                  label="Subject"
                  placeholder="Enter Subject"
                  formik={formik}
                  name="subject"
                  width="w-full md:-mt-2"
                />
                <NuTextArea
                  label="HTML content"
                  type="text"
                  formik={formik}
                  placeholder="Enter Message"
                  name="html"
                  new_width="w-full"
                  row="6"
                />

                <div className="flex justify-end mt-4">
                  <button
                    type="button"
                    onClick={CloseEdit}
                    className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-baseColor-primary px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                  >
                    Submit
                  </button>
                </div>
              </form>

              {/* Right: Live Preview */}
              <div className="w-1/2 border rounded bg-white shadow">
                {renderFullTemplate()}
              </div>
            </div>
          </div>
        }
        handleClick={() => {}}
        closeModal={() => setIsEdit(false)}
        hasButton={false}
        hasContent={true}
      />
    </>
  );
}

export default ViewMore;
